// extracted by mini-css-extract-plugin
export default {"container":"szl7q931JTx6GVZBdeET","closeButton":"qRI3LpOmLmYpo4l3C8lG","validatedIcon":"dWccIbrjiVuKq8UExwAZ"};